// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".IFWlY {\n  top: 0;\n  left: 0;\n  position: fixed !important;\n  height: var(--schoolinks-appbar-height);\n  z-index: 1299 !important;\n  -webkit-box-shadow: rgba(0, 0, 0, 0.2) 0 2px 20px !important;\n          box-shadow: rgba(0, 0, 0, 0.2) 0 2px 20px !important;\n}\n\n.VnCcl {\n  padding: 0 !important;\n}\n\n.F-0bw {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.clkxq {\n  padding-right: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  right: 0;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.yzoGT {\n  width: 100%;\n}\n.yzoGT .F-0bw {\n  width: 100%;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "IFWlY",
	"toolbar": "VnCcl",
	"leftIcons": "F-0bw",
	"rightIcons": "clkxq",
	"publicMemberToolbar": "yzoGT"
};
export default ___CSS_LOADER_EXPORT___;
